import * as authRoutines from './authRoutines';
import * as userRoutines from '../../sagas/routines/userRoutines';

const authReducer = (
    state = {
        client_id: null,
        isAuthenticating: false,
        reauthModalStatus: false,
    },
    action,
) => {
    switch (action.type) {
        case authRoutines.commandCenterLogin.SUCCESS:
            return {
                ...state,
                client_id: action.payload.clientId,
                loggedIn: true,
            };

        case authRoutines.commandCenterLogout.SUCCESS:
            return {
                ...state,
                loggedIn: true,
            };

        case userRoutines.checkUser.SUCCESS:
            return {
                ...state,
                loggedIn: true,
            };


        case authRoutines.isAuthenticating.TRIGGER:
            return {
                ...state,
                isAuthenticating: action.payload,
            };
        case authRoutines.reauthModalStatus.TRIGGER:
            return {
                ...state,
                reauthModalStatus: action.payload,
            };
        default:
            return state;
    }
};
export default authReducer;
